// extracted by mini-css-extract-plugin
module.exports = {"group-company-form__title":"_1Xue81rxq7G0Li_mf7NiOW","group-company-form__half-width":"LClo0_DodfdtJtAhvaW7D"};